import { render, staticRenderFns } from "./NFTDetailsContent.vue?vue&type=template&id=61133fdf"
import script from "./NFTDetailsContent.vue?vue&type=script&lang=js"
export * from "./NFTDetailsContent.vue?vue&type=script&lang=js"
import style0 from "./NFTDetailsContent.vue?vue&type=style&index=0&id=61133fdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports